import { ThemeProvider } from '@codezo/theme';
import '@codezo/theme/src/global.css';
import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { ForgotPasswordPage } from './auth/ForgotPasswordPage';
import { LoginPage } from './auth/LoginPage';
import { MFAEmailVerifyPage } from './auth/MFAEmailVerifyPage';
import { MFAVerifyPage } from './auth/MFAVerifyPage';
import { RegisterMFAPage } from './auth/RegisterMFAPage';
import { RegisterPage } from './auth/RegisterPage';
import { ResetPasswordNewPage } from './auth/ResetPasswordNewPage';
import { ResetPasswordValidatePage } from './auth/ResetPasswordValidatePage';
import { RegisterRedirect } from './components/RegisterRedirect';
import { AuthLayout } from './layouts/AuthLayout';
import { PublicLayout } from './layouts/PublicLayout';
import { SignupLayout } from './layouts/SignupLayout';
import { LandingPage } from './pages/LandingPage';
import { SignupPage } from './pages/SignupPage';
import { ResubscribePage } from './pages/ResubscribePage';
import { UnsubscribePage } from './pages/UnsubscribePage';
import { UserSignupPage } from './pages/UserSignupPage';
import { theme } from './theme.config';

export default function App() {
	return (
		<MantineProvider theme={theme} defaultColorScheme="light" forceColorScheme="light">
			<ThemeProvider>
				<Router>
					<Routes>
						<Route path="/register" element={<RegisterRedirect />} />
						<Route path="/" element={<PublicLayout />}>
							<Route index element={<LandingPage />} />
						</Route>
						<Route path="/signup" element={<SignupLayout />}>
							<Route index element={<SignupPage />} />
							<Route path="user" element={<UserSignupPage />} />
						</Route>
						<Route path="/unsubscribe" element={<UnsubscribePage />} />
						<Route path="/resubscribe" element={<ResubscribePage />} />
						<Route path="/auth" element={<AuthLayout />}>
							<Route path="login" element={<LoginPage />} />
							<Route path="forgot-password" element={<ForgotPasswordPage />} />
							<Route
								path="reset-password/validate"
								element={<ResetPasswordValidatePage />}
							/>
							<Route path="reset-password/new" element={<ResetPasswordNewPage />} />
							<Route path="mfa/verify" element={<MFAVerifyPage />} />
							<Route path="mfa/email-verify" element={<MFAEmailVerifyPage />} />
							<Route path="register" element={<RegisterPage />} />
							<Route path="register/mfa" element={<RegisterMFAPage />} />
						</Route>
					</Routes>
				</Router>
			</ThemeProvider>
		</MantineProvider>
	);
}
